var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useRef, useEffect, useCallback, useMemo, } from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import styled from '@emotion/styled';
import { Transition } from 'react-transition-group';
import VisuallyHidden from '../../../common/components/VisuallyHidden';
import { display, fontSize, space, minWidth, width, position, flex, flexDirection, themeGet, lineHeight, style, } from 'styled-system';
import { useLocalization } from '../../../common/providers/LocaleProvider';
import { useHiddenBodyOverflow } from '../../../common/hooks/scroll';
import { ThemedMedia } from '../../../common/components/Media';
import { getTrackerProps } from '../../../common/tracking/getTrackerProps';
import dispatchTrackingEvent from '../../../common/tracking/dispatchTrackingEvent';
import clearIcon from '../../../common/assets/icons/delete.svg';
import arrowLeftIcon from '../../../common/assets/icons/arrow-left.svg';
import SearchClient from '../../clients/SearchClient';
import { Img } from './Img';
import { SuggestionsList, SuggestionsListItem } from './SuggestionList';
import { SearchSubmitButton } from './SearchSubmitButton';
import { TransitionedIconButton } from './TransitionedButton';
var TRANSITION_MS = 360;
var pointerEvents = style({
    prop: 'pointerEvents',
    cssProperty: 'pointerEvents',
});
var getSuggestionName = function (suggestion) {
    return suggestion == null ? '' : suggestion.name;
};
var SearchFormContainer = styled.div(position, flex, flexDirection, width, minWidth, space, function (props) {
    var transitionState = props.transitionState, timeout = props.timeout;
    var appear = ['entering', 'entered'].includes(transitionState);
    return __assign(__assign(__assign({ boxSizing: 'border-box', backgroundColor: 'transparent', transitionProperty: 'top, transform, opacity, background-color', 
        // Element is always on the screen, we want it to gain and loose speed
        // while animating, for everything else we will use more common ease-out
        // on showing and ease-in on hiding
        transitionTimingFunction: 'ease-in-out' }, (transitionState !== 'exited' && {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 9999999,
    })), (appear && {
        backgroundColor: 'white',
        transitionDuration: timeout + "ms",
    })), (transitionState !== 'entering' && {
        transitionDuration: timeout + "ms",
        transitionDelay: timeout + "ms",
    }));
});
SearchFormContainer.defaultProps = {
    position: ['static', 'relative'],
    flexDirection: 'column',
    width: 1,
    my: 0,
    mx: 'auto',
};
var FormWrapper = styled.div(space);
FormWrapper.defaultProps = {
    pt: [3, 0],
};
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n"], ["\n  position: relative;\n  display: flex;\n"])));
var SearchInputBorder = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n\n  position: relative;\n  border: 1px solid;\n  overflow: hidden;\n  background-color: white;\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n\n  position: relative;\n  border: 1px solid;\n  overflow: hidden;\n  background-color: white;\n\n  ",
    ";\n"])), display, flex, function (props) {
    var focused = props.focused, locked = props.locked, timeout = props.timeout, theme = props.theme;
    return __assign({ borderRadius: theme.isHome24 ? (locked ? '3px' : '3px 0 0 3px') : 0, marginLeft: locked ? 0 : '-40px', transitionProperty: 'margin-left', borderColor: focused
            ? themeGet('colors.gray.9')(props)
            : themeGet('colors.gray.5')(props) }, (locked
        ? {
            // Input border timing functions are coordinated with "Back"
            // button, when button is shown with ease-out, border is in the
            // locked state and should animate accordingly
            transitionTimingFunction: 'ease-out',
            // We apply delay on appear to animate it after the form itself
            // transitioned in the "right" place
            transitionDelay: timeout + "ms",
            transitionDuration: timeout + "ms",
        }
        : {
            transitionTimingFunction: 'ease-in',
            transitionDuration: timeout + "ms",
            borderRight: 'none',
        }));
});
SearchInputBorder.defaultProps = {
    display: 'flex',
    flex: '1 1 auto',
};
var SearchInputContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  position: relative;\n  ", ";\n  ", ";\n  ", ";\n"])), display, flex, space);
SearchInputContainer.defaultProps = {
    display: 'flex',
    flex: '1 1 auto',
};
var SearchInputMobileOverlay = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n"], ["\n  ", ";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n"])), display);
SearchInputMobileOverlay.defaultProps = {
    display: [null, 'none'],
};
var FakeInputMobile = styled(VisuallyHidden)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  /* Prevent iOS autozoom */\n  font-size: 32px;\n"], ["\n  position: fixed;\n  top: 0;\n  /* Prevent iOS autozoom */\n  font-size: 32px;\n"])));
FakeInputMobile.defaultProps = {
    as: 'input',
};
var SearchInput = styled.input(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  width: 100%;\n  border: none;\n  outline: none;\n  text-overflow: ellipsis;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  /* It is really hard to remove browser styles from search field */\n  &[type='search'] {\n    -webkit-appearance: none;\n    /* I hate you, Shop-App */\n    height: auto !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  width: 100%;\n  border: none;\n  outline: none;\n  text-overflow: ellipsis;\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  /* It is really hard to remove browser styles from search field */\n  &[type='search'] {\n    -webkit-appearance: none;\n    /* I hate you, Shop-App */\n    height: auto !important;\n\n    &:invalid {\n      box-shadow: none !important;\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      -webkit-appearance: none;\n    }\n  }\n"])), fontSize, lineHeight, space, pointerEvents, themeGet('colors.gray.5'));
SearchInput.defaultProps = {
    fontSize: 4,
    lineHeight: 3,
    m: 0,
    // -1px correction for the border size
    py: '7px',
    px: 3,
    pointerEvents: ['none', 'auto'],
};
var SuggestionsListContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  overflow-y: auto;\n  height: 100%;\n"], ["\n  overflow-y: auto;\n  height: 100%;\n"])));
function Search(_a) {
    var _this = this;
    var searchDebounce = _a.searchDebounce, suggestionsLimit = _a.suggestionsLimit, searchThreshold = _a.searchThreshold, mobile = _a.mobile, legacyShopRebootMaxWidth = _a.legacyShopRebootMaxWidth;
    var l10n = useLocalization();
    var _b = __read(useState(''), 2), inputValue = _b[0], setInputValue = _b[1];
    var _c = __read(useState([]), 2), suggestions = _c[0], setSuggestions = _c[1];
    var _d = __read(useState(false), 2), locked = _d[0], setLocked = _d[1];
    var _e = __read(useState(false), 2), focused = _e[0], setFocused = _e[1];
    var searchClient = useMemo(function () { return new SearchClient(); }, []);
    var searchContainer = useRef(null);
    var searchPlaceholder = useRef(null);
    var searchInput = useRef(null);
    var fakeInput = useRef(null);
    useHiddenBodyOverflow(focused);
    useEffect(function () {
        var timeout = null;
        var canceled = false;
        var trimmed = inputValue.trim();
        if (trimmed.length >= searchThreshold) {
            timeout = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var result, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, searchClient.getSuggestions(l10n.prefix(), trimmed)];
                        case 1:
                            result = _b.sent();
                            if (!canceled) {
                                setSuggestions(result.slice(0, suggestionsLimit));
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); }, searchDebounce);
        }
        return function () {
            clearTimeout(timeout);
            canceled = true;
        };
    }, [inputValue, searchThreshold, searchDebounce, suggestionsLimit]);
    var lockSearch = useCallback(function () {
        // Before "locked" animation kicks in, we will adjust element top
        // position for animation purposes. As the element has "static" position
        // applied on locked = false, this will not affect it in any way before
        // "entering" phase starts
        var rect = searchContainer.current.getBoundingClientRect();
        searchContainer.current.style.willChange = 'top, background-color';
        searchContainer.current.style.top = rect.top + "px";
        setLocked(true);
    }, [searchContainer]);
    var unlockSearch = useCallback(function () {
        // Before "unlocking" screen, we will adjust the top position
        // to the current placeholder position, so the form animates
        // back to the appropriate place
        var rect = searchPlaceholder.current.getBoundingClientRect();
        searchContainer.current.style.top = rect.top + "px";
        setLocked(false);
        setInputValue('');
        var active = document.activeElement;
        if (active) {
            active.blur();
        }
    }, [searchPlaceholder]);
    var onInputValueChange = useCallback(function (event) {
        setInputValue(event.target.value);
    }, []);
    // Removing this behavior after talking f2f with @Mathias
    // It is inconsistent in current implementation: changes
    // input only with keyboard, but not with mouse highlight
    // and we don't want to make in work for mouse, so the
    // decision is to disable input value change on keyboard
    // highlight all together. Code is left there commented
    // for informational purposes:
    //
    // const onStateChange = useCallback(changes => {
    //   if (changes.hasOwnProperty('highlightedIndex')) {
    //     setInputValue(getSuggestionName(suggestions[changes.highlightedIndex]));
    //   }
    // });
    var opened = useMemo(function () { return inputValue.trim().length >= searchThreshold && suggestions.length > 0; }, [inputValue, searchThreshold, suggestions]);
    var isClearButtonHidden = useMemo(function () { return inputValue.trim().length === 0; }, [
        inputValue,
    ]);
    var action = l10n.prefix(searchClient.config.formActionPath);
    var onSelect = useCallback(function (selectedItem) {
        if (selectedItem && selectedItem.urlEncoded) {
            dispatchTrackingEvent({
                event: 'internal search',
                eventAction: 'click',
                eventCategory: 'link',
                eventData: {
                    label: selectedItem.name,
                    listIndex: suggestions.findIndex(function (item) { return item === selectedItem; }),
                    listItems: suggestions.map(function (item) { return item.name; }),
                    listLength: suggestions.length,
                    searchTerm: inputValue,
                    targetUrl: action + "?query=" + inputValue,
                },
            });
            window.location.href = selectedItem.urlEncoded;
        }
    }, []);
    var onStateChange = useCallback(function (changes) {
        // If the "Esc" key is pressed, "unlock" the screen
        if (changes.type === Downshift.stateChangeTypes.keyDownEscape) {
            unlockSearch();
        }
    }, []);
    return (React.createElement(Transition, { in: locked, timeout: TRANSITION_MS, onEnter: function () {
            // After we set the top in `lockSearch` callback remove
            // the top value from styles to start "entering" animation
            searchContainer.current.style.top = null;
        }, onEntered: function () {
            // After the animation ended, move focus to the real input
            // field (iOS keyboard is already on screen, everything is fine)
            searchInput.current.focus();
        }, onExited: function () {
            // After exit animation, clean inline styles
            searchContainer.current.style.willChange = null;
            searchContainer.current.style.top = null;
        } }, function (lockedTransitionState) { return (React.createElement(Downshift, { inputValue: inputValue, itemToString: getSuggestionName, isOpen: opened, onSelect: onSelect, onStateChange: onStateChange }, function (_a) {
        var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, getItemProps = _a.getItemProps, getLabelProps = _a.getLabelProps, getMenuProps = _a.getMenuProps, highlightedIndex = _a.highlightedIndex, isOpen = _a.isOpen;
        var rootProps = getRootProps({
            onFocus: function () {
                setFocused(true);
            },
            onBlur: function () {
                setFocused(false);
            },
            // Form container animation is half the time of the whole
            // animation cycle. We sync a lot of things with the same timeout
            // allowing to show the form first, before animating buttons
            timeout: TRANSITION_MS / 2,
            transitionState: lockedTransitionState,
            ref: searchContainer,
            'data-testid': 'search-container',
        }, 
        // Downshift doesn't recognize that the ref is passed correctly
        // https://github.com/downshift-js/downshift#getrootprops
        { suppressRefError: true });
        var formProps = getTrackerProps({
            action: action,
            onClick: function (event) {
                // Prevent default click tracking on the form. This
                // will allow to push event only when it is coming from
                // submit event
                event.nativeEvent.trackingPreventDefault = true;
            },
            locked: locked,
        }, {
            event: 'internal search',
            eventData: {
                placement: 'header',
                searchTerm: inputValue,
                targetUrl: action + "?query=" + inputValue,
            },
        });
        var inputProps = getInputProps({
            name: 'query',
            type: 'text',
            required: true,
            placeholder: l10n.t('h24_search_product'),
            onChange: onInputValueChange,
            ref: searchInput,
            'data-testid': 'search-bar-input',
            pointerEvents: locked ? 'auto' : undefined,
        });
        var menuProps = getMenuProps({
            isOpen: isOpen,
            timeout: TRANSITION_MS / 2,
            'data-testid': 'suggestion-list',
        });
        return (React.createElement(React.Fragment, null,
            React.createElement(SearchFormContainer, __assign({}, rootProps),
                React.createElement(FormWrapper
                // Adjust paddings when locked
                , { 
                    // Adjust paddings when locked
                    px: lockedTransitionState === 'exited' ? 0 : 3, pb: lockedTransitionState === 'exited' ? 0 : '12px' },
                    React.createElement(Form, __assign({}, formProps),
                        React.createElement(TransitionedIconButton, { type: "button", "data-testid": "search-back-button", onClick: function () {
                                // It is only possible to unlock search modal
                                // with the button
                                // https://home24.atlassian.net/browse/CNN-597
                                unlockSearch();
                            }, timeout: TRANSITION_MS, 
                            // Back button will appear with delay after SearchFormContainer
                            // finished animating, but will disappear first
                            delay: TRANSITION_MS / 2, hidden: !locked, "aria-hidden": !locked, tabIndex: !locked ? -1 : 0, hideToLeft: true, mr: 2 },
                            React.createElement(VisuallyHidden, null, l10n.t('h24_back')),
                            React.createElement(Img, { "data-testid": "back-button-icon", src: arrowLeftIcon, alt: l10n.t('h24_back') })),
                        React.createElement(VisuallyHidden, __assign({}, getLabelProps({ as: 'label' })), l10n.t('h24_search_product')),
                        React.createElement(SearchInputBorder, { locked: locked, focused: focused, timeout: TRANSITION_MS / 2 },
                            React.createElement(SearchInputContainer
                            // Adjusting container size when the
                            // clear button is hidden
                            , { 
                                // Adjusting container size when the
                                // clear button is hidden
                                mr: isClearButtonHidden ? '-32px' : 0 },
                                !locked && (
                                // This overlay will only be visible on mobile
                                // and only when the form is not "locked". We need
                                // it to work around iOS bugs with screen auto scroll
                                // when focusing on the inputs that are not completely
                                // in the upper part of the page.
                                //
                                // This overlay will trigger focus on the FakeInputMobile
                                // that is always on the top of the page, and this fake
                                // input will start the lock screen process
                                React.createElement(SearchInputMobileOverlay, { "data-testid": "search-overlay", onClick: function () {
                                        // Triggering focus immediately on click allows
                                        // for iOS keyboard to appear on the screen
                                        fakeInput.current.focus();
                                    }, onFocus: function () {
                                        // Same as above
                                        fakeInput.current.focus();
                                    }, tabIndex: 0 })),
                                React.createElement(SearchInput, __assign({}, inputProps))),
                            React.createElement(TransitionedIconButton, { type: "button", "data-testid": "search-clear-button", onClick: function () {
                                    // On clear button interaction, clean input and focus back to the input
                                    // so users can start typing immediately
                                    setInputValue('');
                                    if (searchInput.current) {
                                        searchInput.current.focus();
                                    }
                                }, hidden: isClearButtonHidden, "aria-hidden": isClearButtonHidden, tabIndex: isClearButtonHidden ? -1 : 0, timeout: TRANSITION_MS / 2, hideToRight: true },
                                React.createElement(VisuallyHidden, null, l10n.t('h24_clear_search')),
                                React.createElement(Img, { "data-testid": "clear-search-icon", src: clearIcon, alt: l10n.t('h24_clear_search') }))),
                        React.createElement(SearchSubmitButton, { type: "submit", timeout: TRANSITION_MS, transitionState: lockedTransitionState }, l10n.t('h24_search_button_text')))),
                React.createElement(Transition, { in: isOpen, timeout: TRANSITION_MS / 2, 
                    // We clear the suggestions state on animation exit
                    // so the content is properly animated without jumping
                    // around. If we do this before, there will be no rendered
                    // items to animate
                    onExited: function () {
                        setSuggestions([]);
                    } },
                    React.createElement(SuggestionsListContainer, null,
                        React.createElement(SuggestionsList, __assign({ maxWidth: legacyShopRebootMaxWidth
                                ? [null, '388px']
                                : [null, '388px', null, '480px'] }, menuProps), suggestions.map(function (item, index) {
                            item = __assign(__assign({}, item), { url: l10n.prefix(item.url), urlEncoded: l10n.prefix(item.urlEncoded) });
                            return (React.createElement(SuggestionsListItem, __assign({ key: item.name }, getItemProps({
                                item: item,
                                index: index,
                                // Downshift "swallows" item from the props,
                                // we have to pass it with different key
                                suggestionItem: item,
                                highlighted: highlightedIndex === index,
                                inputValue: inputValue,
                                mobile: mobile,
                                // Tracking data
                                listIndex: index,
                                listItems: suggestions.map(function (el) { return el.name; }),
                            })), item.name));
                        }))))),
            React.createElement("div", { "aria-hidden": "true", ref: searchPlaceholder, style: {
                    display: lockedTransitionState === 'exited' ? 'none' : 'block',
                    // Search height 40px + padding top 16px, we can do some fancy calculations for
                    // this but eh...
                    height: '56px',
                } }),
            mobile && (React.createElement("label", { htmlFor: "search-box-input-focus-helper" },
                React.createElement(FakeInputMobile, { ref: fakeInput, onFocus: lockSearch, id: "search-box-input-focus-helper", "aria-label": inputProps.placeholder, "data-testid": "search-box-input-focus-helper" })))));
    })); }));
}
Search.propTypes = {
    searchDebounce: PropTypes.number,
    suggestionsLimit: PropTypes.number,
    searchThreshold: PropTypes.number,
    mobile: PropTypes.bool,
    legacyShopRebootMaxWidth: PropTypes.bool,
};
Search.defaultProps = {
    searchDebounce: 100,
    searchThreshold: 2,
    suggestionsLimit: 10,
    legacyShopRebootMaxWidth: true,
};
var SearchWithMedia = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(ThemedMedia, null, function (_a) {
        var tablet = _a.tablet;
        return React.createElement(Search, __assign({ mobile: !tablet }, props));
    }));
};
export default SearchWithMedia;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
